import React from "react";

const DEFAULT_TEXT = "بلغ العلي بكماله كشف الدجى جماله صالة صلوا عليه عليه واله واله";

const Header = ({ text = DEFAULT_TEXT, textColor = "#ffffff" }) => (
  <div className="w-full pt-2">
    <div 
        className="text-[5svh] text-center font-arabic"
        style={{ color: textColor }}
    >
      {text}
    </div>
    <div className="w-screen px-0">
      <hr className="mt-3 border-t-4" style={{ borderColor: textColor }} />
    </div>
  </div>
);

export default Header;